module.exports = __webpack_public_path__ + "img/case-logo-11.87c9d443.png";